import { useLingui } from '@lingui/react/macro';
import PictureInPictureAltIcon from '@mui/icons-material/PictureInPictureAlt';
import { Box, CircularProgress, IconButton, Tooltip } from '@mui/material';
import { lazy, memo, Suspense, useCallback } from 'react';
import { PipRoot, usePipWindow } from 'ui-kit';

const OrdersPip = lazy(() => import('./OrdersPip').then((module) => ({ default: module.OrdersPip })));

const buttonSx = { marginLeft: 0.5 } as const;

const pipFallbackSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  minHeight: 120,
} as const;

export const PipButton = memo(function PipButton() {
  const { t } = useLingui();
  const { pipWindow, open, isSupported } = usePipWindow({ width: 360, height: 560 });

  const handleOpen = useCallback(() => {
    void open();
  }, [open]);

  const tooltip = t({
    comment: 'Header tooltip for the picture-in-picture button',
    message: 'Pop out',
  });

  if (!isSupported) return null;

  return (
    <>
      <Tooltip title={tooltip} arrow placement="bottom">
        <IconButton sx={buttonSx} onClick={handleOpen} aria-label={tooltip}>
          <PictureInPictureAltIcon />
        </IconButton>
      </Tooltip>
      {pipWindow ? (
        <PipRoot pipWindow={pipWindow}>
          <Suspense
            fallback={
              <Box sx={pipFallbackSx}>
                <CircularProgress size={24} />
              </Box>
            }
          >
            <OrdersPip />
          </Suspense>
        </PipRoot>
      ) : null}
    </>
  );
});
